<template>
  <div class="smaller-container-wrapper full-height no-progress-bar text-center py-5">
    <div>
      <div class="copy-container">
        <img :src="require('@/assets/paper-check.svg')" alt="" />
        <h2 data-test="thank-you-heading">{{ $t('message.buildAndPrice.contactDealer.thankYou.heading') }}</h2>
        <p class="mt-4 mb-5" data-test="thank-you-msg">
          {{ $t('message.buildAndPrice.contactDealer.thankYou.msg', { dealership: getBusinessName }) }}
        </p>
      </div>
      <MobialisButton @click="clickBtn()" data-test="btn-text"
        >{{ $t('message.buildAndPrice.returnToBuild') }}
      </MobialisButton>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ContactDealerThankYou',
  computed: {
    ...mapGetters('business', ['getBusinessName']),
  },
  methods: {
    async clickBtn() {
      this.$router.push({ path: this.getNextRoutePath() });
    },
  },
};
</script>

<style lang="scss" scoped>
.copy-container {
  max-width: 300px;
  margin: 0 auto;
}
@media (min-width: 576px) {
  .copy-container {
    max-width: 570px;
    p {
      max-width: 490px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .btn {
    width: auto !important;
  }
}
</style>
